import React from 'react'
import { useEffect, useRef, useState } from 'react'
import { DateRange } from 'react-date-range'
import frameX from '../../assets/images/smallxmark.png'
import format from 'date-fns/format'
import { addDays, parse, toDate } from 'date-fns'
// import 'react-date-range/dist/styles.css'
import './dateRange.scss'
import { useNavigate } from 'react-router'
import { useDispatch, useSelector } from 'react-redux'
import {
  fetchCurrentTripForm,
  updateDateRange,
  updateDaysCount,
} from '../../redux/features/tripFormSlice'

export default function DateRangeComp() {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const tripFormData = useSelector(fetchCurrentTripForm)
  // date state
  const [range, setRange] = useState([
    {
      startDate: tripFormData?.rPiker?.startDate
        ? new Date(tripFormData?.rPiker?.startDate)
        : new Date(),
      endDate: tripFormData?.rPiker?.endDate
        ? new Date(tripFormData?.rPiker?.endDate)
        : addDays(new Date(), 7),
      key: 'selection',
    },
  ])

  const handleDatesValue = (e) => {
    const selectedDate = {
      startDate: range[0].startDate.toString(),
      endDate: range[0].endDate.toString(),
      dateString: `${format(
        new Date(range[0].startDate),
        'E, d LLL',
      )} - ${format(new Date(range[0].endDate), 'E, d LLL')}`,
    }
    dispatch(updateDateRange(selectedDate))

    const differenceInTime =
      range[0].endDate.getTime() - range[0].startDate.getTime()
    const differenceInDays = differenceInTime / (1000 * 3600 * 24)

    dispatch(updateDaysCount(differenceInDays))

    navigate(-1)
  }

  // open close
  const [open, setOpen] = useState(true)

  // get the target element to toggle
  const refOne = useRef(null)

  // useEffect(() => {
  //   // event listeners
  //   document.addEventListener("keydown", hideOnEscape, true)
  //   document.addEventListener("click", hideOnClickOutside, true)
  // }, [])

  // hide dropdown on ESC press
  const hideOnEscape = (e) => {
    // console.log(e.key)
    if (e.key === 'Escape') {
      setOpen(false)
    }
  }

  // Hide on outside click
  // const hideOnClickOutside = (e) => {
  //   // console.log(refOne.current)
  //   // console.log(e.target)
  //   if( refOne.current && !refOne.current.contains(e.target) ) {
  //     setOpen(false)

  //   }
  // }
  return (
    <>
      <div className="calendarWrap" style={{ height: '92vh' }}>
        {/* <input
      value={`${format(range[0].startDate, "MM/dd/yyyy")} to ${format(range[0].endDate, "MM/dd/yyyy")}`}
      readOnly
      className="inputBox"
      onClick={ () => setOpen(open => !open) }
    /> */}
        <div className="title_content_top" style={{ marginBottom: '8px' }}>
          <p className="title2">Select dates</p>
          <img
            className="close"
            src={frameX}
            onClick={() => navigate(-1)}
            style={{ marginTop: '3px' }}
            alt="close"
          />
        </div>
        <div className="dateRange_inp">
          <div className="dateRange_inp_items">
            <label for="startDate">Start date</label>
            <input
              value={`${format(new Date(range[0].startDate), 'E, d LLL')}`}
              readOnly
              className="inputBox"
              onClick={() => setOpen((open) => !open)}
              name="startDate"
              placeholder="Select date"
            />
          </div>

          <div className="dateRange_inp_items">
            <label for="endDate">End date</label>
            <input
              value={`${format(new Date(range[0].endDate), 'E, d LLL')} `}
              readOnly
              className="inputBox"
              onClick={() => setOpen((open) => !open)}
              name="endDate"
              placeholder="Select date"
            />
          </div>
        </div>
        <div ref={refOne}>
          {open && (
            <DateRange
              onChange={(item) => setRange([item.selection])}
              editableDateInputs={true}
              moveRangeOnFirstSelection={false}
              ranges={range}
              months={1}
              direction="horizontal"
              className="calendarElement"
            />
          )}
        </div>
      </div>
      <footer
        className="create-button-save"
        style={{ height: '56px', width: '100%', padding: '8px 0' }}
      >
        <button
          className="btn-create"
          variant="contained"
          style={{ width: '90%', backgroundColor: '#00857D', color: '#FFFFFF' }}
          type="submit"
          fullWidth
          // onClick={hideOnClickOutside}
          onClick={handleDatesValue}
        >
          Done
        </button>
      </footer>
    </>
  )
}
